import React from "react";
import { useParams } from "react-router-dom";
import MetaData from "../../layout/MetaData";
import { useGetUserDetailsQuery } from "../../../redux/api/userApi";
import "../../../css/Admin.css";
import Loader from "../../layout/Loader";
import "../../../css/Driver.css";

const DriverPayments = () => {
  const params = useParams();
  const { data, isLoading } = useGetUserDetailsQuery(params?.id);

  const user = data?.userDetail || {};

  const {
    _id,
    name,
    email,
    phoneNo,
    payment,
    paymentHistory = [], // Default to empty array if undefined
  } = user;

  return (
    <>
      <MetaData title={"Payment History"} />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="container mt-5">
          <h2 className="mb-4">Driver Basic Detail</h2>
          <table className="table table-bordered mb-5">
            <tbody>
              <tr>
                <th scope="row">Driver ID</th>
                <td>{_id}</td>
              </tr>
              <tr>
                <th scope="row">Name</th>
                <td>{name}</td>
              </tr>

              <tr>
              <th scope="row">phone number</th>
                <td>{phoneNo || "Phone Number"}</td>
              </tr>
            </tbody>
          </table>

          {/* Payment History Table */}
          <h2 className="mb-4">Driver Payment History (Payments Done By Driver)</h2>
          {paymentHistory.length === 0 ? (
            <p>No payment history available.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Total Price Of booking</th>
                    <th>MBZ Cut</th>
                    <th>Driver's Cut</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((entry, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>Rs. {entry.totalEarned}</td>
                      <td>Rs. {entry.mbzCut}</td>
                      <td>Rs. {entry.driversCut}</td>
                      <td>{new Date(entry.date).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

           <br />
           <br />

        {/* current dues */}
        <h2 className="mb-4">Drivers Current Dues</h2>
        <h4 className="mb-4">THIS RESETS AND BECOMES 0 AFTER DRIVER PAYS US OUR MONEY</h4>
          <table className="table table-bordered mb-5">
            <tbody>
              <tr>
                <th scope="row">Our cut that driver needs to give to us to unpause their account</th>
                <td>{payment.mbzCut}</td>
              </tr>
              {/* <tr>
                <th scope="row">Drivers Cut that driver has subtracted from cash until he owed us </th>
                <td>{payment.driversCut}</td>
              </tr>
              <tr>
                <th scope="row">Total money that the driver collected</th>
                <td>{payment.totalEarned}</td>
              </tr> */}
            </tbody>
          </table>

        </div>
      )}
    </>
  );
};

export default DriverPayments;
